<div class="div_venue div_menu_wrapper">
  <div class="pos-title-header">
    <label class="lbl_top">{{'TAX_RATE.DEFINE_TAX_RATES' | translate}}</label>
    <button class="create_btn responsive_btn" (click)="addTaxRate()">
      <span class="hide_mobile">{{'TAX_RATE.ADD' | translate}}</span>
      <i class="show_mobile pi pi-plus-circle"></i>
    </button>
  </div>
  <div class="cards_div_wrapper">
    <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
    <div *ngFor="let tax_rate of listAllTaxRates" class="tax_rate_div">
      <div>
        <span>
          <div class="menu_dropdown_helper pe-0 pt-0" #icon (click)="menu.toggle($event)"></div>
          <i class="pi pi-ellipsis-v spam-menu manager-emp-menu" (click)="icon.click()"></i>
          <p-menu #menu class="edit-menu header-menu" [popup]="true" [model]="items[tax_rate.id]"></p-menu>
        </span>
      </div>
      <div class="div_content">
        <label class="w-100 tax-rate-name" title="{{tax_rate.name}}">{{tax_rate.name}}</label>
        <label class="w-100 tax-rate-rate"
               title="{{tax_rate.name}}">{{'TAX_RATE.RATE' | translate}}: {{tax_rate.rate}}%</label>
        <span class="tax-rate-created">{{'TAX_RATE.CREATED' | translate}}: {{tax_rate.createdOn | date: 'dd-MM-YYYY'}}</span>
      </div>
    </div>
  </div>
</div>
